import { render } from "./ArchiveManager.vue?vue&type=template&id=6fbd35cb&scoped=true"
import script from "./ArchiveManager.vue?vue&type=script&lang=js"
export * from "./ArchiveManager.vue?vue&type=script&lang=js"

import "./ArchiveManager.vue?vue&type=style&index=0&id=6fbd35cb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbd35cb"]])

export default __exports__